
export default {
  data () {
    return { link: process.env.BACKEND_URL + '/api/login/facebook', free_month: false }
  },
  watch: {
    '$consent.state.analytics' () { this.refreshLink() }
  },
  mounted () {
    this.free_month = !!this.getCookie('free-month')
    this.refreshLink()
  },
  methods: {
    refreshLink (event) {
      const attribution = this.$consent.attribution()
      const params = new URLSearchParams({ utm_source: attribution.source, first_page_visited: attribution.first_page_visited })
      if (this.free_month) params.set('free_month', '1')
      this.link = process.env.BACKEND_URL + '/api/login/facebook?' + params.toString()
      if (event) event.currentTarget.href = this.link
    }
  }
}
